module.exports = __webpack_public_path__ + "img/login-v2.80cac88d.svg";